<template>
    <div class="rest_monitor">
        <div class="rest_monitor_header">
            <div class="rest_back" @click="goHome"></div>
            <div class="rest_title">堆场监控</div>
        </div>
        <div class="rest_monitor_conter">
            <div class="rest_card">
                <div class="rest_card_text">生效时间
                    <span :class="{ effect: isEffect }">{{ isEffect ? '(已生效)' : '(未生效)' }}</span>
                </div>
                <div class="rest_time" style="margin-top:10px">
                    <el-date-picker
                        v-model="search.startTime"
                        type="datetime"
                        style="width:100%"
                        :editable="false"
                        @focus="timeEditable"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择开始时间">
                    </el-date-picker>
                </div>
                <div class="rest_time">
                    <el-date-picker
                        v-model="search.endTime"
                        type="datetime"
                        :editable="false"
                        @focus="timeEditable"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width:100%"
                        placeholder="选择结束时间">
                    </el-date-picker>
                </div>
            </div>
            <div class="card_lists">
                <div class="card_lists_index" v-for="(item,index) in dataList" :key="index">
                    <div class="card_lists_header">
                        <div class="card_lists_text">堆场名称</div>
                        <div class="card_lists_data">{{item.deviceName}}</div>
                    </div>
                    <div class="card_lists_item">
                        <div class="item_text">环数</div>
                        <div class="item_datas">
                            <el-input type="number" v-model="item.ringNum" placeholder="请输入环数"></el-input>
                        </div>
                    </div>
                    <div class="card_lists_item">
                        <div class="item_text">管片数量</div>
                        <div class="item_datas">
                            <el-input type="number" v-model="item.pipeNum" placeholder="请输入管片数量"></el-input>
                        </div>
                    </div>
                    <div class="card_lists_item">
                        <div class="item_text">容量占比(%)</div>
                        <div class="item_datas">
                            <el-input type="number" v-model="item.capacityProportion" placeholder="请输入容量占比"></el-input>
                        </div>
                    </div>
                    <div class="card_lists_item">
                        <div class="item_text">龄期</div>
                        <div class="item_datas">
                            <el-input type="number" v-model="item.age" placeholder="请输入龄期"></el-input>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card_btn" @click="submitYards">
                <el-button >提交</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import { throttle} from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
export default {
    data(){
        return{
            isEffect: false,
            search:{},
            dataList:[],
        }
    },
    mounted(){
        window.document.title="堆场监控"
        this.getInfos()
    },
    methods:{
        //获取信息
        getInfos(){
            let params = {
            }
            this.$api.screenCms.showH5YardInfo(params).then(res=>{
                if(res.statusMsg==='ok'){
                    this.dataList = res.data
                    this.$set(this.search,'startTime',res.data[0].startTime)
                    this.$set(this.search,'endTime',res.data[0].endTime)
                    this.checkoutEffect()
                }else{
                    this.$message.warning(res.statusMsg)
                }
            })
        },
        //返回首页
        goHome(){
            this.$router.push({path:'/screenCmsHome'})
        },
        //禁止手动输入
        timeEditable(){
            this.$nextTick(() => {
                let els = document.querySelectorAll('.el-date-picker__editor-wrap input');
                for(var i = 0; i <= els.length-1 ; i++){
                    els[i].setAttribute('readonly','readonly');
                }
            })
        },
        // 是否生效
        checkoutEffect() {
            let { startTime, endTime } = this.search
            if (startTime && endTime) {
                if (+new Date(startTime) <= +new Date() && +new Date() < +new Date(endTime)) {
                this.isEffect = true
                return
                }
            }
            this.isEffect = false
        },
        // 验证: 生效时间(结束 > 开始)
        validate() {
          let validated = true
          let { startTime, endTime } = this.search
            if (!startTime || !endTime) {
                this.$message.warning('生效时间未填')
                return
            }
          if (startTime && endTime && +new Date(startTime) >= +new Date(endTime)) {
            this.$message.warning('结束时间 必须大于 开始时间')
                return
          }
          return validated
        },
        // 节流提交
        throttleSubmit: throttle(function () {
            let obj = {
                list:this.dataList,
                startTime:!this.search.startTime?'':this.search.startTime,
                endTime:!this.search.endTime?'':this.search.endTime
            }
            this.$api.screenCms.submitH5YardInfo(obj).then(res=>{
                if(res.statusMsg==='ok'){
                    this.$message.success('提交成功')
                    this.getInfos()
                }else{
                    this.$message.warning(res.statusMsg)
                }
            })
        }, 3000),
        //提交信息
        submitYards(){
          if (this.validate()) {
            this.throttleSubmit()
          }
        }
    }
}
</script>
<style scoped lang="scss">
/* 滚动条统一样式修改 */
/deep/ {
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px transparent;
    background: #39b5fe;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 10px;
    background: rgba(76, 188, 254, 0.3);
  }
}
.rest_monitor{
    width: 100%;
    height: 100%;
    background-color: #F6F8FE;
    position: relative;

    .rest_monitor_header{
        width: 100%;
        height: 136px;
        background: url("../../assets/opration/rest_bgh.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        .rest_back{
            width: 9px;
            height: 16px;
            background: url("../../assets/opration/rest_back.png") no-repeat;
            background-size: 100% 100%;
            position: absolute;
            top: 25px;
            left: 15px;
        }
        .rest_title{
            font-size: 17px;
            font-weight:600;
            letter-spacing: 3px;
            color: rgba(255, 255, 255, .92);
            position: absolute;
            top: 25px;
            left: 50%;
            margin-left: -40px;
        }
    }
    .rest_monitor_conter{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 12%;
        padding: 0 15px;
        .rest_card{
            width: 100%;
            height: 141px;
            border-radius: 4px;
            background: #ffffff;
            padding: 15px;

            .rest_card_text{
                color: rgba(51, 51, 51, 1);
                font-size: 18px;
                font-weight: bold;
                > span {
                    font-size: 14px;
                    color: red;
                    &.effect {
                        color: #00d154;
                    }
                }
            }
            .rest_time{
                padding: 5px;
            }
            
        }
        .card_lists{
            height: calc(70% - 42px);
            overflow: auto;
            .card_lists_index{
                width: 100%;
                border-radius: 4px;
                margin-top: 10px;background: #ffffff;
                padding: 15px;

                .card_lists_header{
                    width: 100%;
                    background:rgba(225, 237, 255, 1);
                    display: flex;
                    justify-content: space-between;
                    padding: 10px 15px;
                    align-items: center;
                    border-radius: 5px;
                    .card_lists_text{
                        margin-right: 10px;
                        font-size: 18px;
                        font-weight: bold;
                        white-space: nowrap;
                        color: rgba(51, 51, 51, 1);
                    }
                    .card_lists_data{
                        color: rgba(35, 126, 255, 1);
                        font-size: 18px;
                        font-weight: bold;
                    }
                }

                .card_lists_item{
                    padding: 10px 0;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border-bottom: 1px solid rgba(225, 237, 255, 1);
                    .item_text{
                        flex: none;
                        color: rgba(49, 51, 64, 1);
                        font-size: 16px;
                        font-weight: 400;
                        margin-right: 10px;
                    }
                    /deep/.item_datas .el-input__inner{
                        border: 0;
                        text-align: right;
                    }
                    /deep/.item_datas .el-input__inner::placeholder{
                        position: absolute;
                        top: 8px;
                        right: 0px;
                    }
                }
            }
        }
        /deep/.card_btn .el-button{
            background: none;
            color: rgba(255, 255, 255, .92);
            font-size: 18px;
        }
        .card_btn{
            background-color: rgba(35, 126, 255, 1);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 5px;
        }
    }
}
@media only screen and (min-width: 600px) {
  .rest_monitor {
    position: absolute;
    width: 600px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>